import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth")({
  component: AuthLayoutRoute,
});

function AuthLayoutRoute() {
  return (
    <div className="min-h-screen bg-background">
      <Outlet />
    </div>
  );
}
